// hooks/useArticles.ts
import { useQuery } from "@tanstack/react-query";
import { fetcher } from "../../utils/fetchers";
import {
  getAdminAccessToken,
  getStoreAccessToken,
  getStoreId,
} from "../../utils/auth";
import { Transaction } from "../../types/modules/transaction.type";

interface UseTransactionsParams {
  status?: string;
  page?: number;
  limit?: number;
  storeId?: number;
}

export const useStoreTransactions = ({
  status,
  page = 1,
  limit = 10,
  storeId,
}: UseTransactionsParams) => {
  const queryParams = new URLSearchParams({
    page: page.toString(),
    limit: limit.toString(),
  });

  if (status) {
    queryParams.append("status", status);
  }

  if (storeId) {
    queryParams.append("storeId", storeId.toString());
  }

  const storeIdToSend = storeId ? storeId : getStoreId();
  const token = storeId ? getAdminAccessToken() : getStoreAccessToken();

  return useQuery({
    queryKey: ["store-transaction", page, limit, storeIdToSend, status, token],
    queryFn: () =>
      fetcher<{ data: Transaction[]; totalPages: number; totalItems: number }>(
        `store-transaction/current-store?${queryParams.toString()}`,
        token
      ),
  });
};
